
import React from 'react';
import apiFetch from '@wordpress/api-fetch';
import {Navigation, Pagination, Autoplay, EffectFade, EffectCube, EffectFlip} from 'swiper/modules';
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react';
import {css, keyframes} from '@emotion/css';
import * as lodash from 'lodash';
import * as dateFns from 'date-fns';
import { getTimeSectionAndMenuKind } from '../helper';

export default class EventSignage extends React.Component {

    constructor(props) {
        super(props);
        const searchParams = new URLSearchParams(window.location.search);
        const signage_id = searchParams.get('signage_id');
        this.state = {
            cafeteria_base: {
                cafeteria_name: '',
                cafeteria_logo: '',
                cafeteria_tax: 'in_tax_price',
                cafeteria_open_saturday: true,
                cafeteria_open_sunday: true,
                cafeteria_time_section_1_from: '',
                cafeteria_time_section_1_to: '',
                cafeteria_time_section_2_from: '',
                cafeteria_time_section_2_to: '',
                cafeteria_time_section_3_from: '',
                cafeteria_time_section_3_to: '',
                cafeteria_time_section_4_from: '',
                cafeteria_time_section_4_to: '',
                cafeteria_time_section_1_smt_from: '',
                cafeteria_time_section_1_smt_to: '',
                cafeteria_time_section_2_smt_from: '',
                cafeteria_time_section_2_smt_to: '',
                cafeteria_time_section_3_smt_from: '',
                cafeteria_time_section_3_smt_to: '',
                cafeteria_time_section_4_smt_from: '',
                cafeteria_time_section_4_smt_to: '',
                cafeteria_board_quantity: 1,
                cafeteria_event_quantity: 1,
                cafeteria_corner_quantity: 1,    
            },
            cafeteria_event: [
                {
                    display_direction: 'horizontal',
                    delay: 30,
                    animation_speed: 2,
                    animation_type: 'slide',
                }
            ],
            is_initialize: false,
            signage_id: signage_id && signage_id !== '' ? Number(signage_id) - 1 : 0,
            provide_date: dateFns.format(new Date(), 'yyyyMMdd'),
            time_section: '1',
            event_news: [],
        }
    }

    fetchEvents = async () => {
        try {
            // 各種設定の取得
            const res = await apiFetch({
                path: '/wp-json/cafeteria_api/signage_setting'
            });

            // 集合サイネージ数、コーナー数の初期値
            let cafeteria_event_quantity = 1;

            // 提供年月日、時間帯区分の初期値
            let provide_date = dateFns.format(new Date(), 'yyyyMMdd');
            let time_section = '0';

            // 基本設定の取得及び設定
            if (res.cafeteria_info_base_setting) {
                if (res.cafeteria_info_base_setting.cafeteria_event_quantity) {
                    cafeteria_event_quantity = res.cafeteria_info_base_setting.cafeteria_event_quantity;
                }
                const res_time_section = getTimeSectionAndMenuKind(
                    res.cafeteria_info_base_setting.cafeteria_time_section_1_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_1_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_2_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_2_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_3_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_3_to,
                    res.cafeteria_info_base_setting.cafeteria_time_section_4_from,
                    res.cafeteria_info_base_setting.cafeteria_time_section_4_to,
                );
                provide_date = res_time_section.provide_date;
                time_section = res_time_section.time_section;
                this.setState({
                    cafeteria_base: res.cafeteria_info_base_setting,
                    provide_date: provide_date,
                    time_section: time_section,
                });
            }

            // イベント／お知らせを取得
            const query_for_signage_id = this.state.signage_id + 1;
            const event_news_path = '/wp-json/wp/v2/event_news?per_page=100&acf_format=standard&signage_view=1&target_signage=' + query_for_signage_id + '&provide_date=' + provide_date + '&time_section=0,' + time_section;
            const event_news = await apiFetch({
                path: event_news_path
            });

            if (event_news) {
                this.setState({
                    event_news: event_news,
                });
            }

            // サイネージ設定の取得及び設定
            if (res.cafeteria_info_event_setting) {
                // 取得したイベント／お知らせ設定の数が、イベント／お知らせサイネージ数よりも少ない場合、不足分を補完
                if (res.cafeteria_info_event_setting.cafeteria_event.length < cafeteria_event_quantity) {
                    const add_array_count = cafeteria_event_quantity - res.cafeteria_info_event_setting.cafeteria_event.length;
                    for (let i = 0; i < add_array_count; i++) {
                        const values = {
                            display_direction: 'horizontal',
                            delay: 30,
                            animation_speed: 2,
                            animation_type: 'slide',
                        };
                        res.cafeteria_info_event_setting.cafeteria_event.push(values);
                    }        
                } else if (res.cafeteria_info_event_setting.cafeteria_event.length > cafeteria_event_quantity) {
                    // 取得数に余剰がある場合、余剰分を削除
                    const del_array_count = res.cafeteria_info_event_setting.cafeteria_event.length - cafeteria_event_quantity;
                    for (let i = 0; i < del_array_count; i++) {
                        res.cafeteria_info_event_setting.cafeteria_event.pop();
                    }        
                }
                this.setState({
                    cafeteria_event: res.cafeteria_info_event_setting.cafeteria_event,
                    is_initialize: true,
                });
            } else {
                // 取得できなかった（未設定）場合、初期値から足りないイベント／お知らせサイネージ数だけ補完
                const clone_event = lodash.cloneDeep(this.state.cafeteria_event);
                for (let i = 0; i < cafeteria_event_quantity; i++) {
                    if (clone_event[i] === undefined) {
                        const values = {
                            display_direction: 'horizontal',
                            delay: 30,
                            animation_speed: 2,
                            animation_type: 'slide',
                        };
                        clone_event.push(values);
                    }
                }
                this.setState({
                    cafeteria_event: clone_event,
                    is_initialize: true,
                });
            }
        } catch (e) {
            // なにかしらエラーが発生した場合も、継続して更新を発生させるため、ログ出力のみで中断はしない
            console.log(e);
        }

        // 10秒間隔毎に更新する
        setTimeout(this.fetchEvents, 10000);
    }

    async componentDidMount() {
        // 初期処理
        this.fetchEvents();
    }

    render() {
        // スライダー一覧のDOM作成
        const events = [];
        const len = this.state.event_news.length;
        for (let i = 0; i < len; i++) {
            events.push(
                <SwiperSlide>
                    <div className="event-signage-layout-slide">
                        <img src={this.state.event_news[i].acf.event_img.url} />
                    </div>
                </SwiperSlide>
            );
        }

        return (
            <React.Fragment>
                {
                    !this.state.is_initialize &&
                    <div>読み込み中...</div>
                }
                {
                    this.state.is_initialize &&
                    <div className={this.state.cafeteria_event[this.state.signage_id].display_direction === 'horizontal' ? 'event-signage-layout-horizontal' : 'event-signage-layout-vertical'}>
                        {
                            this.state.cafeteria_event[this.state.signage_id].animation_type === 'slide' &&
                            <Swiper
                                modules={[Autoplay]}
                                loop={len > 1 ? true : false}
                                pagination={false}
                                navigation={false}
                                autoplay={{
                                    delay: Math.trunc(this.state.cafeteria_event[this.state.signage_id].delay * 1000),
                                    disableOnInteraction: false,
                                }}
                                speed={Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000)}
                                onUpdate={(val) => val.slideNext(Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000))}
                            >
                                {events}
                            </Swiper>
                        }
                        {
                            this.state.cafeteria_event[this.state.signage_id].animation_type === 'fade' &&
                            <Swiper
                                modules={[Autoplay, EffectFade]}
                                loop={len > 1 ? true : false}
                                pagination={false}
                                navigation={false}
                                autoplay={{
                                    delay: Math.trunc(this.state.cafeteria_event[this.state.signage_id].delay * 1000),
                                    disableOnInteraction: false,
                                }}
                                speed={Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000)}
                                effect="fade"
                                fadeEffect={{
                                    crossFade: false,
                                }}
                                onUpdate={(val) => val.slideNext(Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000))}
                            >
                                {events}
                            </Swiper>
                        }
                        {
                            this.state.cafeteria_event[this.state.signage_id].animation_type === 'cube' &&
                            <Swiper
                                modules={[Autoplay, EffectCube]}
                                loop={len > 1 ? true : false}
                                pagination={false}
                                navigation={false}
                                autoplay={{
                                    delay: Math.trunc(this.state.cafeteria_event[this.state.signage_id].delay * 1000),
                                    disableOnInteraction: false,
                                }}
                                speed={Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000)}
                                effect="cube"
                                cubeEffect={{
                                    shadow: false,
                                    slideShadows: false,
                                }}
                                onUpdate={(val) => val.slideNext(Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000))}
                            >
                                {events}
                            </Swiper>
                        }
                        {
                            this.state.cafeteria_event[this.state.signage_id].animation_type === 'flip' &&
                            <Swiper
                                modules={[Autoplay, EffectFlip]}
                                loop={len > 1 ? true : false}
                                pagination={false}
                                navigation={false}
                                autoplay={{
                                    delay: Math.trunc(this.state.cafeteria_event[this.state.signage_id].delay * 1000),
                                    disableOnInteraction: false,
                                }}
                                speed={Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000)}
                                effect="flip"
                                flipEffect={{
                                    slideShadows: false,
                                }}
                                onUpdate={(val) => val.slideNext(Math.trunc(this.state.cafeteria_event[this.state.signage_id].animation_speed * 1000))}
                            >
                                {events}
                            </Swiper>
                        }
                    </div>
                }
            </React.Fragment>
        );
    }
}
